import React from 'react'
import Header from './header'

const FullscreenMapLayout = ({ headerProps, mapComponent, children }) => {
  return (
    <div
      id='container'
      className='flex flex--column-reverse bg-white select-none absolute top right bottom left hmax-full'
    >
      <div className='flex-child-grow relative flex flex--column'>
        {mapComponent}
        {/* medium+ sidebar */}
        <div className='absolute left mx6 my6 px6 py6 top-ml w360 none block-ml z4'>
          <div className='bg-white h-auto-ml hmax-full px12 py12 round-ml scroll-auto shadow-darken25 shadow-none-ml viewport-third'>
            {children}
          </div>
        </div>
        {/* end medium+ sidebar */}
        <div className='px12 py12 block none-ml hmax240 overflow-scroll'>
          {children}
        </div>
      </div>
      <Header {...headerProps} />
    </div>
  )
}

export default FullscreenMapLayout
